const DIETARY_TAGS = ['Vegetarian', 'Vegan', 'Pescatarian', 'Halal', 'Kosher', 'Keto'];

interface MealTagBadgeProps {
  text: string;
}

export function MealTagBadge({ text }: MealTagBadgeProps) {
  const isDietary = DIETARY_TAGS.includes(text);
  const colorClass = isDietary
    ? 'text-blue-600 bg-blue-100 dark:text-blue-400 dark:bg-blue-900/30'
    : 'text-green-600 bg-green-100 dark:text-green-400 dark:bg-green-900/30';

  return (
    <span className={`text-xs px-1.5 py-0.5 rounded ${colorClass}`}>
      {text}
    </span>
  );
}
